var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueDocReceived(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 3.59687L11.9996 10.7969M11.9996 10.7969L14.3996 8.09687M11.9996 10.7969L9.59961 8.09688",
    stroke: "#1552E8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59961 13.2031H6.25423C7.01457 13.2031 7.39474 13.2031 7.72892 13.3286C8.06309 13.4541 8.3105 13.6897 8.80533 14.161L9.31389 14.6453C9.80871 15.1166 10.0561 15.3522 10.3903 15.4777C10.7245 15.6031 11.1046 15.6031 11.865 15.6031H12.1342C12.8946 15.6031 13.2747 15.6031 13.6089 15.4777C13.9431 15.3522 14.1905 15.1166 14.6853 14.6453L15.1939 14.161C15.6887 13.6897 15.9361 13.4541 16.2703 13.3286C16.6045 13.2031 16.9846 13.2031 17.745 13.2031H20.3996",
    stroke: "#1552E8",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1996 3.60156C17.5647 3.7367 18.4836 4.0421 19.1695 4.73232C20.3996 5.97032 20.3996 7.96286 20.3996 11.9479C20.3996 15.933 20.3996 17.9256 19.1695 19.1636C17.9393 20.4016 15.9594 20.4016 11.9996 20.4016C8.03981 20.4016 6.05991 20.4016 4.82976 19.1636C3.59961 17.9256 3.59961 15.933 3.59961 11.9479C3.59961 7.96286 3.59961 5.97032 4.82976 4.73232C5.5156 4.0421 6.43449 3.7367 7.79961 3.60156",
    stroke: "#1552E8",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueDocReceived);
export default __webpack_public_path__ + "static/media/BlueDocReceived.cf46221efcc2bb519dd986ecef62985e.svg";
export { ForwardRef as ReactComponent };